
const timeoffWorkflowUsersBulkUploadColumns = [
  {
    field: "",
    key: "numbering",
    title: "#",
    width: 10,
    align: "center",
    type: "expand",
    renderBodyCell: ({ rowIndex }) => {
      return ++rowIndex;
    },
  },
 
  {
    field: "EmployeeNo",
    key: "EmployeeNo",
    title: "EmployeeNo",
    headerAlign: "left",
    align: "left",
  
  },
  {
    field: "WorkflowName",
    key: "WorkflowName",
    title: "Workflow Name",
    headerAlign: "left",
    align: "left",
  },
 
];

export default timeoffWorkflowUsersBulkUploadColumns;
